import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Editor } from "react-draft-wysiwyg";
import {
  convertToRaw,
  EditorState,
  convertFromHTML,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import useLogs from "hooks/logs";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  FormLabel,
  Grid,
  TextField,
  FormGroup,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
} from "@material-ui/core";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import { IsMobile } from "utils/is-mobile";

const RadioOption = withStyles(() => ({
  label: {
    fontSize: "1rem",
  },
  root: {
    marginBottom: 0,
  },
}))(FormControlLabel);

const useStyles = makeStyles({
  editorClass: {
    padding: "0.15rem",
    border: "solid 1px #c5c5c5",
    borderRadius: "0.5rem",
  },
});

const getSelectedDefaultValue = (selected, options, idKey) => {
  return options.find((option) => option[idKey] === parseInt(selected, 10));
};

export function DialogCreateRelease({ open, onClose, selectedRow, typeView }) {
  const snackbar = useSnackbar();
  const classes = useStyles();
  const { setLocalStorageActions, setLocalStorageApiProblem } = useLogs();

  const isMobile = IsMobile();

  const [submitting, setSubmitting] = useState(false);
  const [name, setName] = useState("");
  const [version, setVersion] = useState("");
  const [system, setSystem] = useState("PORTAL");
  const [rawDescription, setRawDescription] = useState(() =>
    EditorState.createEmpty()
  );
  const [content, setContent] = useState("");
  const [descriptionDefaultValue, setDescriptionDefaultValue] = useState(() =>
    EditorState.createEmpty()
  );
  const [validateOptions, setValidateOptions] = useState(false);
  const [activateRelease, setActivateRelease] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState([]);
  const [profileListDefault, setProfileListDefault] = useState(null);
  const [buttonType, setButtonType] = useState("create");

  const handleClose = () => {
    onClose();
  };

  const handleGetProfiles = async () => {
    await Api.get("list-profile", "adminportal", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setProfiles(Result);
        }
      })
      .catch((error) => {
        setLocalStorageApiProblem({
          idMenuAccess: "161",
          screen: "Release Notes",
          problem: `Erro na chamada do endpoint list-profile - ${error}`,
        });
        snackbar.showMessage(error, {
          severity: "error",
        });
      });
  };

  const handleCreateEditRelease = async () => {
    setSubmitting(true);

    const profileList = [];
    selectedProfile?.map((item) => profileList?.push(item?.IdPerfil));

    if (selectedRow !== null) {
      const descriptionValue = draftToHtml(
        convertToRaw(descriptionDefaultValue.getCurrentContent())
      );
      await Api.put(
        "edit-release-product",
        "conteudo",
        {
          idReleaseSistemaProduto:
            selectedRow?.IdReleaseSistemaProduto?.toString(),
          titulo: name,
          descricao: descriptionValue,
          versaoSistema: system === "APP" ? version : "",
          idSistemaIntegracao: system,
          idsPerfil: profileList?.join(",")?.toString(),
        },
        true
      )
        .then((res) => {
          if (res.Success) {
            snackbar.showMessage(res?.Result?.MessageResponse, {
              severity: "success",
            });
            setTimeout(() => {
              onClose(true);
            }, 1000);
          }
        })
        .catch((error) => {
          setLocalStorageApiProblem({
            idMenuAccess: "161",
            screen: "Release Notes",
            problem: `Erro na chamada do endpoint edit-release-product - ${error}`,
          });
          snackbar.showMessage(error, {
            severity: "error",
          });
        })
        .finally(() => setSubmitting(false));
    } else {
      const descriptionValue = draftToHtml(
        convertToRaw(rawDescription.getCurrentContent())
      );
      await Api.post(
        "create-release-product",
        "conteudo",
        {
          titulo: name,
          descricao: descriptionValue,
          versaoSistema: system === "APP" ? version : "",
          idSistemaIntegracao: system,
          idsPerfil: profileList?.join(",")?.toString(),
        },
        true
      )
        .then((res) => {
          if (res.Success) {
            snackbar.showMessage(res?.Result?.MessageResponse, {
              severity: "success",
            });
            setTimeout(() => {
              onClose(true);
            }, 1000);
          }
        })
        .catch((error) => {
          setLocalStorageApiProblem({
            idMenuAccess: "161",
            screen: "Release Notes",
            problem: `Erro na chamada do endpoint create-release-product - ${error}`,
          });
          snackbar.showMessage(error, {
            severity: "error",
          });
        })
        .finally(() => setSubmitting(false));
    }
  };

  const handleActivateRelease = async () => {
    setActivateRelease(true);

    await Api.put(
      "edit-release-product",
      "conteudo",
      {
        idReleaseSistemaProduto:
          selectedRow?.IdReleaseSistemaProduto?.toString(),
        ativo: "true",
      },
      true
    )
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage("Release lançada com sucesso!", {
            severity: "success",
          });
          setTimeout(() => {
            onClose(true);
          }, 1000);
        }
      })
      .catch((error) => {
        setLocalStorageApiProblem({
          idMenuAccess: "161",
          screen: "Release Notes",
          problem: `Erro na chamada do endpoint edit-release-product - ${error}`,
        });
        snackbar.showMessage(error, {
          severity: "error",
        });
      })
      .finally(() => setActivateRelease(false));
  };

  const onProfileChange = (newValue) => {
    if (newValue?.length === 0) {
      setSelectedProfile([]);
    }

    if (newValue?.length !== 0 && newValue !== "all") {
      setSelectedProfile(newValue);
    }
  };

  const handleValidateButton = () => {
    const descriptionValueRaw =
      convertToRaw(rawDescription.getCurrentContent()).blocks[0].text.trim() !==
      "";

    const descriptionValue =
      convertToRaw(
        descriptionDefaultValue.getCurrentContent()
      ).blocks[0].text.trim() !== "";

    if (
      name === "" ||
      selectedProfile?.length === 0 ||
      selectedProfile === null ||
      (selectedRow !== null && !descriptionValue) ||
      (selectedRow === null && !descriptionValueRaw)
    ) {
      setValidateOptions(false);
      snackbar.showMessage("Todos os campos devem ser preenchidos.", {
        severity: "error",
      });
    } else {
      setValidateOptions(true);
    }
  };

  useEffect(() => {
    if (system === "PORTAL") {
      setVersion("");
    }
  }, [system]);

  useEffect(() => {
    if (selectedRow !== null) {
      setName(selectedRow?.Titulo);
      setSystem(selectedRow?.IdSistemaIntegracao);
      setVersion(selectedRow?.VersaoSistema);
      setProfileListDefault(selectedRow?.Perfil);

      const html = selectedRow?.Descricao;
      const blocksFromHTML = convertFromHTML(html);

      const customContentStateConverter = (contentState) => {
        const newBlockMap = contentState.getBlockMap().map((block) => {
          const entityKey = block.getEntityAt(0);
          if (entityKey !== null) {
            const entityBlock = contentState.getEntity(entityKey);
            const entityType = entityBlock.getType();
            switch (entityType) {
              case "IMAGE": {
                const newBlock = block.merge({
                  type: "atomic",
                  text: "img",
                });
                return newBlock;
              }
              default:
                return block;
            }
          }
          return block;
        });
        const newContentState = contentState.set("blockMap", newBlockMap);
        return newContentState;
      };

      setContent(
        customContentStateConverter(
          ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap
          )
        )
      );
    }
  }, [selectedRow]);

  useEffect(() => {
    if (content) {
      setDescriptionDefaultValue(() => EditorState.createWithContent(content));
    }
  }, [content]);

  useEffect(() => {
    if (validateOptions && buttonType === "create") {
      handleCreateEditRelease();
    } else if (validateOptions && buttonType === "activate") {
      handleActivateRelease();
    }
  }, [validateOptions, buttonType]);

  useEffect(() => {
    handleGetProfiles();
    setLocalStorageActions({
      nomeTela: "Release Notes",
      idMenu: "161",
      acao: "Acessou a tela Criação de Release Notes",
    });
  }, []);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
      >
        <form>
          <DialogTitle>
            <span>
              <Typography id="alert-dialog-title" variant="h3" component="h3">
                {typeView === "edit"
                  ? "Editar "
                  : typeView === "view"
                  ? " "
                  : "Criar "}{" "}
                Release Note
              </Typography>
            </span>
          </DialogTitle>
          <PerfectScrollbar>
            <DialogContent style={{ padding: "1rem 1.5rem 1.5rem" }}>
              <>
                <Grid container>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormLabel required>Nome</FormLabel>
                      <TextField
                        name="name"
                        required
                        fullWidth
                        disabled={submitting || typeView === "view"}
                        value={name}
                        variant="outlined"
                        onChange={(e) => setName(e.target.value)}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .toString()
                            .slice(0, 200);
                        }}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    hidden={typeView === "edit" || typeView === "view"}
                  >
                    <FormGroup>
                      <FormLabel required>Descrição</FormLabel>
                      <Editor
                        editorState={rawDescription}
                        onEditorStateChange={setRawDescription}
                        wrapperClassName={classes.editorClass}
                        editorClassName={classes.editorClass}
                        toolbarClassName={classes.editorClass}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} hidden={typeView === null}>
                    <FormGroup>
                      <FormLabel required>Descrição</FormLabel>
                      <Editor
                        editorState={descriptionDefaultValue}
                        onEditorStateChange={setDescriptionDefaultValue}
                        wrapperClassName={classes.editorClass}
                        editorClassName={classes.editorClass}
                        toolbarClassName={classes.editorClass}
                        readOnly={typeView === "view"}
                        toolbar={typeView === "view" && { options: [] }}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} hidden={typeView === "view"}>
                    <AutoCompleteField
                      optionIdKey="IdPerfil"
                      options={profiles}
                      label="Perfis"
                      value={selectedProfile}
                      onChange={onProfileChange}
                      disabled={submitting || typeView === "view"}
                      loading={profiles?.length === 0}
                      multiple
                      required
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    hidden={typeView !== "view"}
                    style={{
                      paddingBottom: "0.75rem",
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                    }}
                  >
                    {profileListDefault?.map((profile) => (
                      <Chip
                        style={{ margin: isMobile ? "0.3rem" : "0rem 0.3rem" }}
                        key={profile.IdPerfil}
                        label={profile.NomePerfil}
                      />
                    ))}
                  </Grid>
                  <Grid></Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <FormGroup>
                      <FormLabel required>Sistema</FormLabel>
                      <RadioGroup
                        aria-label="opções de sistemas"
                        required
                        name="sistema"
                        value={system}
                        disabled={submitting || typeView === "view"}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(2,1fr)",
                        }}
                      >
                        <RadioOption
                          key={"PORTAL"}
                          value={"PORTAL"}
                          onClick={() => {
                            setSystem("PORTAL");
                          }}
                          disabled={submitting || typeView === "view"}
                          checked={system === "PORTAL"}
                          control={<Radio size="small" color="primary" />}
                          label="Portal"
                        />
                        <RadioOption
                          key={"APP"}
                          value={"APP"}
                          onClick={() => {
                            setSystem("APP");
                          }}
                          disabled={submitting || typeView === "view"}
                          checked={system === "APP"}
                          control={<Radio size="small" color="primary" />}
                          label="App"
                        />
                      </RadioGroup>
                    </FormGroup>
                    <FormGroup hidden={system === "PORTAL"}>
                      <FormLabel required>Versão</FormLabel>
                      <TextField
                        name="version"
                        required
                        fullWidth
                        disabled={submitting || typeView === "view"}
                        value={version}
                        variant="outlined"
                        onChange={(e) => setVersion(e.target.value)}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .toString()
                            .slice(0, 20);
                        }}
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
              </>
              {submitting && (
                <div style={{ marginTop: "1rem" }}>
                  <span>
                    {selectedRow !== null ? "Editando " : "Criando "} release...
                  </span>
                  <LinearProgress />
                </div>
              )}
              {activateRelease && (
                <div style={{ marginTop: "1rem" }}>
                  <span>Lançando release...</span>
                  <LinearProgress />
                </div>
              )}
            </DialogContent>
          </PerfectScrollbar>
          <DialogActions>
            <Button component={Box} onClick={handleClose} disabled={submitting}>
              {typeView === "view" ? "Fechar" : "Cancelar"}
            </Button>

            <Button
              hidden={typeView === "view"}
              color="default"
              variant="contained"
              type="button"
              onClick={() => {
                handleValidateButton();
                setButtonType("create");
              }}
              disabled={submitting}
            >
              {selectedRow !== null ? "Editar " : "Criar "}
            </Button>
            <Button
              hidden={typeView === "view" || typeView === null}
              color="default"
              variant="contained"
              type="button"
              onClick={() => {
                handleValidateButton();
                setButtonType("activate");
              }}
              disabled={submitting}
            >
              Lançar release
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
